import React from "react";
import { Badge } from "@/components/ui/badge";
import { STATUS_LABELS, STATUS_CLASS } from "@/lib/api";
import { TIDS } from "@/lib/testIds";

export const StatusPill = ({ status }) => (
  <Badge
    variant="outline"
    data-testid={TIDS.referralStatusBadge}
    className={`rounded-full px-3 py-1 text-xs font-medium ${STATUS_CLASS[status] || "bg-slate-100 text-slate-700 border-slate-200"}`}
  >
    {STATUS_LABELS[status] || status}
  </Badge>
);
